import { useAppAction, useAppSelector } from '../hooks';
import { PropertiesManagementState } from './propertyManagementTypes';
import { PROPERTIES_MANAGEMENT_NAMESPACE } from './propertyManagementReducer';
import { propertyManagementFetchLocationTreeThunk } from './propertyManagementActions';

export function usePropertyManagementSelector<
  T extends (state: PropertiesManagementState) => any
>(selector: T): ReturnType<T> {
  return useAppSelector((state) =>
    selector(state[PROPERTIES_MANAGEMENT_NAMESPACE])
  );
}

export const usePropertyManagementLocation = () =>
  usePropertyManagementSelector((state) => {
    return state.location;
  });

export const usePropertyManagementBuildings = () =>
  usePropertyManagementSelector((state) => {
    return state.location?.buildings;
  });

export const usePropertyManagementFloorsByBuildingVisitId = (visitId: string) =>
  usePropertyManagementSelector((state) => {
    return state.location?.buildings.find(
      (building) => building.code === visitId
    )?.floors;
  });

export const useFetchPropertyManagementLocationTree = () =>
  useAppAction(propertyManagementFetchLocationTreeThunk);
